export default __webpack_public_path__ + "static/media/Boye (4).521e8552.jpg";